import React from 'react';
import { Box, Autocomplete, TextField } from '@mui/material';
import { useOcrInputStore } from '../store/ocrInputStore';
import { useAssetSelector } from '../hooks/useAssetSelector';
import { useTemplateSelector } from '../hooks/useTemplateSelector';
import { Asset, ConfiguredTemplate } from '../types/dataInputTypes';

export const DataInputHeader: React.FC = () => {
  const {
    selectedAsset,
    selectedTemplate,
    setSelectedAsset,
    setSelectedTemplate,
    resetOcrData,
  } = useOcrInputStore();

  const {
    options: assets,
    isLoading: isLoadingAssets,
    setSearchQuery: setAssetSearch,
  } = useAssetSelector();

  const {
    options: templates,
    isLoading: isLoadingTemplates,
    setSearchQuery: setTemplateSearch,
  } = useTemplateSelector(selectedAsset!);

  const handleAssetChange = (_: React.SyntheticEvent, newValue: Asset | null) => {
    setSelectedAsset(newValue);
    setSelectedTemplate(null);
    resetOcrData();
  };

  const handleTemplateChange = (
    _: React.SyntheticEvent,
    newValue: ConfiguredTemplate | null
  ) => {
    setSelectedTemplate(newValue);
    resetOcrData();
  };

  const isTemplateSelectorDisabled = !selectedAsset;

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, my: 3 }}>
      <Autocomplete
        options={assets}
        getOptionLabel={(option) => option.assetName}
        isOptionEqualToValue={(option, value) => option.assetId === value.assetId}
        loading={isLoadingAssets}
        value={selectedAsset}
        onChange={handleAssetChange}
        onInputChange={(_, newInputValue) => setAssetSearch(newInputValue)}
        renderInput={(params) => <TextField {...params} label="Asset" />}
        fullWidth
      />
      <Autocomplete
        disabled={isTemplateSelectorDisabled}
        options={templates}
        getOptionLabel={(option) => option.logbookTemplateName}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={isLoadingTemplates}
        value={selectedTemplate}
        onChange={handleTemplateChange}
        onInputChange={(_, newInputValue) => setTemplateSearch(newInputValue)}
        renderInput={(params) => (
          <TextField {...params} label="Logbook Template" />
        )}
        fullWidth
      />
    </Box>
  );
};